/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { UserAuthRequest } from '../entities/UserAuthRequest'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { z } from 'zod'

export const userAuthRequestSchema = z.object({
  email: z.string().max(64),
  password: z.string().min(8).max(64),
}) as unknown as ToZod<UserAuthRequest>